import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ArrowblockEW = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M8 12.75V17l-5-5 5-5v4.244l4 .003 4-.003V7l5 5-5 5v-4.25H8z" id="path-1"></path>
  </SvgIcon>
);

export default ArrowblockEW;
